import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getLastComment = async (docId) => {
  return await request.get(
    `/Docs/last_note/${docId}`,
    null,
    'Произошла ошибка при загрузке последнего комментария'
  );
};

const useLastCommentQuery = (docId, options) =>
  useQuery(queryKeys.lastComment(docId), () => getLastComment(docId), options);

export default useLastCommentQuery;
